export default __webpack_public_path__ + "static/media/msvfooterLogo.efaf943c.png";